<template>
<div class="fulldashboard">
        <div class="feedbackContainerAlert">
             <div class="alertText">
                     {{ alertText }}
            </div>
            <div class="alertBlock">
                    <button @click="optionOneTapped()" class="alertOption"> {{ optionOne }} </button>
            </div>
            <div class="alertBlock">
                    <button @click="optionTwoTapped()" class="alertOption">{{ optionTwo }}</button>
            </div>
                    
        </div>
</div>

</template>

<script>
  export default{
    props:[
      'alertText',
      'optionOne',
      'optionTwo'
    ],
    methods: {
            optionOneTapped() {
                this.$emit('oneTapped')
            },
            optionTwoTapped(){
                this.$emit('twoTapped')
            }
        }
  } 
</script>

<style >
    .feedbackContainerAlert {
      width: 300px;
      height: 130px;
      background-color: grey;
      border-radius: 30px;
      z-index: 30;
        display: table;
        margin: 0 auto;
        margin-top: 250px;
    }
    .alertText{
        padding:25px;
        text-align: center;
    }
    .alertBlock{
        display: block;
        float: left;
        margin-top: -30px;
        width: 50%;
        padding: 20px;
        
    }
    .alertOption{
      width: 100%;
       height: 25px; 
    }
</style>